import { Main } from 'components/Shared/Layout';
import Button from 'components/Shared/Button';
import { rm } from 'utils';

interface LoaderProps {
  error: boolean;
  pastDelay: boolean;
  timedOut: boolean;
  retry: () => void;
}

// TODO: fix timed out components that look nice
export const loading = (props: LoaderProps) => {
  if (props.error || props.timedOut) {
    return (
      <Main>
        <h2>{rm('loading_error_page_text')}</h2>
        <Button onClick={props.retry}>{rm('loading_error_page_button')}</Button>
      </Main>
    );
  }
  // return null to not show spinner before delay is up
  return null;
};
